import React, {useContext, useEffect, useState} from 'react';
import { Link } from "react-router-dom";

import {  Row, Col, Form, Card, Table, Button, InputGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaUserEdit, FaUserTimes, FaUserTag, FaUserPlus } from 'react-icons/fa';
import { RiUserSearchLine } from 'react-icons/ri';
import { GiPalmTree } from 'react-icons/gi';

import UsersAdminContext from "../../../context/Admin/Users/UsersAdminContext";
import Loading from "../../../components/Loading";

import {formatedRun} from "../../../utils/RunUtil";

const AdminUsers = () => {

    const [ userFilter, setUserFilter ] = useState([]);

    const usersAdminContext = useContext(UsersAdminContext);
    const { loading, users, loadUsers, cacheUserSelected, deleteUser} = usersAdminContext;

    const cacheUser = (user) =>{ cacheUserSelected(user)} 
    const onClickDeleteUser = async(email) => { await deleteUser(email)};

    useEffect(() => {
        if(users.length <= 0){
            loadUsers()
        } else {
            setUserFilter(users);
        }
        // eslint-disable-next-line
    }, [users]);

    const filterUser = (e) => {
        let value = e.target.value.toUpperCase()
        setUserFilter(
                users.filter(
                        user => `${user.firstName} ${user.secondName} ${user.lastName} ${user.surName}`.toUpperCase().includes(value)
                    )
            );     
    }
    
    return (
        <>
             <Row>
                <Col>
                    <h1 className="h3 mb-2 text-gray-800">Administración de Usuarios</h1>
                    <hr />
                </Col>
            </Row>

            <Card>
                <Card.Header>Usuarios</Card.Header>
                <Card.Body>
                    <Card.Title></Card.Title>
                    
                    <Card.Text>
                        <Form.Group as={Row} controlId="formHorizontalEmail"> 
                            <Col md={4}>
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text><RiUserSearchLine/></InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control 
                                        size="sm" 
                                        type="text" 
                                        placeholder="Juan Toro ..." 
                                        name="search"
                                        onChange={filterUser}/>
                                </InputGroup>
                               
                            </Col>
                            <Col md={6}></Col>
                            <Col md={2}>
                            
                                <Link to={"/admin/user/form"} onClick={()=>cacheUser({})}>
                                    <Button variant="outline-info" size="sm" >          
                                        <FaUserPlus size={"1rem"} /> &nbsp; {"Agregar Usuario"}
                                    </Button>
                                </Link>
                            </Col>
                        </Form.Group>
                        {loading ? <Loading/> :
                            <Table responsive striped  hover size="sm"  >
                            <thead>
                                <tr>                                       
                                    <th>R.U.N.</th>
                                    <th>Usuario</th>
                                    <th className="text-center">Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {userFilter.map(user => (
                                    <tr key={user.run}>
                                        <td>{formatedRun(user.run)}</td>
                                        <td >{`${user.firstName} ${user.secondName} ${user.lastName} ${user.surName}`}</td>
                                        <td className="text-center">
                                            <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Editar usuario</Tooltip>}>
                                                <Link to={"/admin/user/form"} variant="link" size="sm" onClick={()=>cacheUser(user)}> <FaUserEdit/> </Link>
                                            </OverlayTrigger>
                                            <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Liquidaciones de sueldo</Tooltip>}>
                                                <Link to={"/admin/salarySettlement"} variant="link" size="sm" onClick={()=>cacheUser(user)}> <FaUserTag/> </Link>
                                            </OverlayTrigger>
                                            <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Vacaciones</Tooltip>}>
                                                <Button variant="link" size="sm"> <GiPalmTree/> </Button>
                                            </OverlayTrigger>
                                            <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Eliminar usuario</Tooltip>}>
                                                <Button variant="link" size="sm"> <FaUserTimes className="text-danger" onClick={()=>onClickDeleteUser(user.email)}/> </Button>
                                            </OverlayTrigger>
                                        </td>
                                    </tr>
                                ))}                                
                            </tbody>
                        </Table>                       
                        }
                    </Card.Text>
                    
                </Card.Body>
            </Card>
        </>
      );
}
 
export default AdminUsers;